module.exports = __webpack_public_path__ + "img/histogram_chart.257f7850.svg";